import widgetData from './widgetData';
import vehicleData from './vehicleData';

const root = {
	widgetData,
	vehicleData
};

export default root;
